var SVG = require('svg.pathmorphing2.js');

/**
 * Snimate SVG
 * @author: BenJ
 */
$(document).ready(function() {

    $('.animate-svg').each(initSVGPath)

    // Initilize SVG Path
    function initSVGPath() {
        var $wrap = $(this);
        var $svg = $(this).find('svg');

        var $path = $svg.find('path.svg-path-morph').eq(0);
        if (!$path.length) {
            $path = $svg.find('path').eq(0);
        }

        var $pathTo = $svg.find('path.svg-path-morph-to').eq(0);
        if (!$pathTo.length) {
            $pathTo = $svg.find('path').eq(1);
        }

        if (!$pathTo.length)
            return;

        var boxPath = $path.attr('d');
        var data = $pathTo.attr('d');

        if (!$svg.attr('id')) {
            $svg.attr('id', 'page-hero-svg-' + Math.random().toString(8))
        }

        if (data) {
            function animateSVG(toggle, delay, duration, actionCallback) {
                // create svg
                var draw = SVG($svg[0].id);

                $svg.find('path').remove();

                var dataFrom = toggle ? boxPath : data;
                var dataTo = toggle ? data : boxPath;

                var path = draw.attr({
                    'fill': $path.attr('fill'),
                    'stroke': $path.attr('stroke'),
                    'stroke-width': $path.attr('stroke-width')
                }).path(dataFrom)

                path.stop().animate(duration, actionCallback, delay).plot(dataTo);
            }

            function quadInOut (pos) {
                if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 2)
                return -0.5 * ((pos -= 2) * pos - 2)
            }

            function sineInOut (pos) {
                if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 2)
                return -0.5 * ((pos -= 2) * pos - 2)
            }

            function quartOut(pos) {
                return -(Math.pow((pos - 1), 2) - 1)
            }

            if ($wrap.hasClass('animate-scroll-passed')) {
                document.addEventListener('body-scroller.scroll-passed', function(e){
                    if (!e.detail) return;
                    setTimeout(function () {
                        animateSVG(!e.detail.passed, 0, 3000, quadInOut);
                    }, !e.detail.passed ? 0 : 500)
                })
            }

            if ($wrap.hasClass('animate-inview')) {
                $wrap.one('inview', function () {
                    setTimeout(function () {
                        animateSVG(true, 0, 3000, quadInOut);
                    }, 200)
                })
            } else {
                const isHero = $wrap.parents('.widget').hasClass('widget-hero');
                if (isHero) {
                    animateSVG(true, 0, 1500, sineInOut);
                } else {
                    animateSVG(true, 800, 3000, quartOut);
                }
            }
        }
    }

});
